

















import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class LangingPage extends Vue {
  private navigate() {
    this.$router.push("/demo");
  }
}
